module.exports = __webpack_public_path__ + "img/arrow-down.ef356609.svg";